var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BprListValueDisplay',{attrs:{"index":_vm.index,"content":_vm.content,"isHighlighted":_vm.isHighlighted,"isStaging":_vm.isStaging,"editable":""},on:{"delete":function($event){return _vm.$emit('delete')},"edit":_vm.openEditModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }